<template>
  <div>
    <b-card-body>
      <b-card class="importContainer">
        <b-form>
          <div class="toolbar">
            <select type="button" @change="execCmd('fontName', $event.target.value)" title="Fonte">
              <option value="Arial">Arial</option>
              <option value="Times New Roman">Times New Roman</option>
              <option value="Courier New">Courier New</option>
              <option value="Georgia">Georgia</option>
            </select>
            <select type="button" @change="execCmd('fontSize', $event.target.value)" title="Tamanho da Fonte">
              <option value="1">10px</option>
              <option value="2">13px</option>
              <option value="3">16px</option>
              <option value="4">18px</option>
              <option value="5">24px</option>
              <option value="6">32px</option>
              <option value="7">48px</option>
            </select>
            <div class="toolbar mt-2">
              <button type="button" @click="execCmd('bold')" title="Negrito"><b>B</b></button>
              <button type="button" @click="execCmd('italic')" title="Itálico"><i>I</i></button>
              <button type="button" @click="execCmd('underline')" title="Sublinhado"><u>U</u></button>
              <button type="button" @click="execCmd('insertUnorderedList')" title="Tópicos">
                <i class="fa fa-list-ul"></i>
              </button>
              <button type="button" @click="execCmd('insertOrderedList')" title="Lista Numerada">
                <i class="fa fa-list-ol"></i>
              </button>
            </div>
          </div>

          <b-form-group class="mt-1" :label="$t('texto-inserido')" label-for="editor">
            <div id="editor" class="editor" contenteditable="true"
              style="min-height: 100px; border: 1px solid #ccc; padding: 5px;"></div>
          </b-form-group>
          <b-row class="groupBtn">
            <div class="modal-buttons">
              <img width="30" height="30" class="action-btn" src="@/assets/salvar.png" :title="$t('salvar')"
                @click="saveRichText" />
              <img width="30" height="30" class="action-btn exit-btn" src="@/assets/sair.png" @click="$emit('close')"
                :title="$t('cancelar')" />
            </div>
          </b-row>
        </b-form>
      </b-card>
    </b-card-body>
  </div>
</template>

<script>
import { showError } from "../../../global";

export default {
  name: "TextBoxModal",
  props: {
    textForm: {
      type: Object,
      default: () => ({ content: "", color: "black" })
    }
  },
  
  data() {
    return {
      localText: { ...this.textForm }
    };
  },

  mounted() {
    const editor = document.getElementById("editor");
    if (editor) {
      if (this.localText.content) {
        editor.innerHTML = this.localText.content;
      }
      editor.addEventListener('keydown', this.handleTabKey);
    }
  },

  beforeDestroy() {
    const editor = document.getElementById("editor");
    if (editor) {
      editor.removeEventListener('keydown', this.handleTabKey);
    }
  },

  methods: {
    execCmd(command, value = null) {
      document.execCommand(command, false, value);
    },

    handleTabKey(e) {
      if (e.key === 'Tab') {
        e.preventDefault();
        document.execCommand('insertText', false, '    ');
      }
    },

    saveRichText() {
      const editor = document.getElementById("editor");
      const content = editor ? editor.innerHTML : "";
      if (!content.trim()) {
        showError("Digite algum texto.");
        return;
      }
      this.localText.content = content;
      this.$emit("save", { ...this.localText });
    }
  },
  watch: {
    textForm(newVal) {
      this.localText = { ...newVal };
      const editor = document.getElementById("editor");
      if (editor) {
        editor.innerHTML = this.localText.content;
      }
    }
  }
};
</script>

<style scoped>
.modal-body {
  padding: 0%;
}

.toolbar {
  margin-bottom: 10px;
}

.toolbar button,
.toolbar select {
  margin-right: 5px;
  padding: 5px;
  font-size: 14px;
  cursor: pointer;
}

.groupBtn {
  display: flex;
  justify-content: flex-end;
  margin-top: 32px;
}

.modal-buttons {
  cursor: pointer;
  text-align: right;
}

.exit-btn {
  margin-left: 14px;
  margin-right: 14px;
}

.toolbar {
  display: flex;
  align-items: center;
  gap: 4px;
}

.toolbar button {
  border: none;
  background: transparent;
  padding: 5px;
  cursor: pointer;
  font-size: 16px;
  outline: none;
  margin-right: 0px;
}

.toolbar select {
  border: 1px solid #ccc;
  background: transparent url("@/assets/arrow-down.svg") no-repeat right 10px center;
  background-size: 12px;
  padding: 5px 30px 5px 5px;
  cursor: pointer;
  font-size: 16px;
  outline: none;
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
}

:deep(.modal-body) {
  padding: 0 !important;
}
</style>
